/* brand-header.js — duyuru sayacı + header (mega deste, auto-fit, mobil çekmece, arama, sepet sayacı) (U02).
   Sözleşme: core/CONVENTIONS.md §3. Global yok (window.BRAND yalnız okunur). Bileşenler data-brand-component'e bağlanır,
   olaylar document'a delege edilir: Horizon sepet çekmecesi header'ı yeniden çizse (morph) bile dinleyiciler kaybolmaz.
   Sepet olayları Horizon'dan ('cart:update', assets/events.js); ağ isteği yalnız mağazanın kendi /cart.js'ine.
   İki bölüm aynı dosyayı yükler: ilk çalışan kurar (html[data-brand-header-js] bekçisi). */
(function () {
  'use strict';
  var D = document;
  var H = D.documentElement;
  if (H.hasAttribute('data-brand-header-js')) return;
  H.setAttribute('data-brand-header-js', '');

  var DESK = window.matchMedia ? window.matchMedia('(min-width: 990px)') : null;
  var FIT_MAX = 6;

  function all(sel, root) { return Array.prototype.slice.call((root || D).querySelectorAll(sel)); }
  function headers() { return all('[data-brand-component="header"]'); }
  function routes() { var B = window.BRAND; return (B && B.routes) || {}; }

  /* ---------------- 1. kesim sayacı (A-3; saat metni yok, yalnız geri sayım) ---------------- */
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function startCountdown(el) {
    var B = window.BRAND;
    if (!el || el.getAttribute('data-brand-ready') === '1') return;
    if (!B || !B.flags || B.flags.countdown !== true || !B.facts || !B.facts.cutoff) return;
    var c = B.facts.cutoff;
    var hWeek = parseInt(c.hour, 10);
    var hSat = c.hourSat === null || c.hourSat === undefined || c.hourSat === '' ? NaN : parseInt(c.hourSat, 10);
    if (!c.tz || isNaN(hWeek)) return;
    var fmt;
    try {
      fmt = new Intl.DateTimeFormat('en-US', { timeZone: c.tz, hourCycle: 'h23', weekday: 'short', hour: '2-digit', minute: '2-digit', second: '2-digit' });
    } catch (e) { return; }
    var days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    var label = el.querySelector('[data-brand-bind="countdown.label"]');
    var timer = el.querySelector('[data-brand-bind="countdown.timer"]');
    var item = el.parentNode;
    var fallback = item ? item.querySelector('[data-brand-countdown-fallback]') : null;
    if (!label || !timer) return;
    function hourFor(wd) {
      if (wd >= 1 && wd <= 5) return hWeek;
      if (wd === 6 && !isNaN(hSat)) return hSat;
      return null; /* Pazar üretim yok */
    }
    function put(node, v) { if (node.__v !== v) { node.__v = v; node.textContent = v; } }
    function tick() {
      var o = {};
      fmt.formatToParts(new Date()).forEach(function (p) { o[p.type] = p.value; });
      var wd = days.indexOf(o.weekday);
      var now = (parseInt(o.hour, 10) % 24) * 3600 + parseInt(o.minute, 10) * 60 + parseInt(o.second, 10);
      var h = hourFor(wd), diff = null, today = false;
      if (h !== null && now < h * 3600) { diff = h * 3600 - now; today = true; }
      else {
        for (var d = 1; d <= 7; d++) {
          var hn = hourFor((wd + d) % 7);
          if (hn !== null) { diff = d * 86400 + hn * 3600 - now; break; }
        }
      }
      if (diff === null || diff < 0 || isNaN(diff)) {
        el.hidden = true;
        if (fallback) fallback.hidden = false;
        return;
      }
      var hh = Math.floor(diff / 3600), mm = Math.floor((diff % 3600) / 60), ss = diff % 60;
      put(label, today ? el.getAttribute('data-today') : el.getAttribute('data-next'));
      put(timer, pad(hh) + ':' + pad(mm) + ':' + pad(ss));
      if (el.hidden) {
        el.hidden = false;
        if (fallback) fallback.hidden = true;
      }
    }
    el.setAttribute('data-brand-ready', '1');
    tick();
    setInterval(function () { if (!D.hidden) tick(); }, 1000);
    D.addEventListener('visibilitychange', function () { if (!D.hidden) tick(); });
  }

  /* ---------------- 2. mega deste ---------------- */
  var touchTrigger = null;
  function deckItem(node) { return node && node.closest ? node.closest('.brand-header__item--deck') : null; }
  function setExpanded(item, open) {
    var t = item && item.querySelector('.brand-header__trigger');
    if (t) t.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  function closeDecks(except) {
    all('.brand-header__item--deck.is-open').forEach(function (it) {
      if (it !== except) { it.classList.remove('is-open'); setExpanded(it, false); }
    });
  }
  D.addEventListener('mouseover', function (e) {
    var it = deckItem(e.target);
    if (!it) return;
    var nav = it.closest('.brand-header__nav');
    if (nav && nav.classList.contains('is-suppressed')) return;
    setExpanded(it, true);
  });
  D.addEventListener('mouseout', function (e) {
    var it = deckItem(e.target);
    if (!it || (e.relatedTarget && it.contains(e.relatedTarget))) return;
    if (!it.classList.contains('is-open') && !it.contains(D.activeElement)) setExpanded(it, false);
  });
  D.addEventListener('focusin', function (e) {
    var it = deckItem(e.target);
    all('.brand-header__nav.is-suppressed').forEach(function (n) { if (!it || !n.contains(it)) n.classList.remove('is-suppressed'); });
    if (it) setExpanded(it, true);
  });
  D.addEventListener('focusout', function (e) {
    var it = deckItem(e.target);
    if (!it) return;
    setTimeout(function () { if (!it.contains(D.activeElement) && !it.classList.contains('is-open')) setExpanded(it, false); }, 0);
  });
  D.addEventListener('mousemove', function (e) {
    var nav = e.target.closest && e.target.closest('.brand-header__nav.is-suppressed');
    if (!nav) all('.brand-header__nav.is-suppressed').forEach(function (n) { n.classList.remove('is-suppressed'); });
  }, { passive: true });
  /* dokunmatik geniş ekran (tablet yatay): ilk dokunuş desteyi açar, ikincisi linke gider */
  D.addEventListener('pointerdown', function (e) {
    touchTrigger = e.pointerType === 'touch' && e.target.closest ? e.target.closest('.brand-header__item--deck > .brand-header__trigger') : null;
  }, { passive: true });

  /* ---------------- 3. mobil çekmece ---------------- */
  function drawerOf(btn) { return btn ? D.getElementById(btn.getAttribute('aria-controls')) : null; }
  function openDrawer(btn) {
    var dlg = drawerOf(btn);
    if (!dlg || typeof dlg.showModal !== 'function' || dlg.open) return false;
    closeDecks(null);
    dlg.showModal();
    var x = dlg.querySelector('[data-brand-header-close]');
    if (x) x.focus({ preventScroll: true });
    btn.setAttribute('aria-expanded', 'true');
    H.setAttribute('scroll-lock', '');
    return true;
  }
  function closeDrawers() {
    all('dialog.brand-header__drawer[open]').forEach(function (dlg) { dlg.close(); });
  }
  D.addEventListener('close', function (e) {
    var dlg = e.target;
    if (!dlg || !dlg.classList || !dlg.classList.contains('brand-header__drawer')) return;
    if (!D.querySelector('dialog[open][scroll-lock], dialog.brand-header__drawer[open]')) H.removeAttribute('scroll-lock');
    var other = D.querySelector('dialog[open]');
    all('[data-brand-header-open][aria-controls="' + dlg.id + '"]').forEach(function (b) {
      b.setAttribute('aria-expanded', 'false');
      /* odak menü düğmesine döner; arama/sepet çekmecesi açıldıysa onların odağına dokunulmaz */
      if (!other && b.offsetParent !== null) b.focus({ preventScroll: true });
    });
  }, true);

  /* ---------------- 4. tıklama yönlendirici ---------------- */
  D.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var trig = t.closest('.brand-header__item--deck > .brand-header__trigger');
    if (trig && touchTrigger === trig) {
      var it = trig.parentNode;
      if (!it.classList.contains('is-open')) {
        e.preventDefault();
        closeDecks(it);
        it.classList.add('is-open');
        setExpanded(it, true);
        return;
      }
    }
    if (!t.closest('.brand-header__item--deck')) closeDecks(null);

    var opener = t.closest('[data-brand-header-open]');
    if (opener) { e.preventDefault(); openDrawer(opener); return; }

    if (t.closest('[data-brand-header-close]')) { e.preventDefault(); closeDrawers(); return; }

    /* <dialog> arka planına tıklama: hedef dialog'un kendisi ve imleç kutunun dışında */
    if (t.classList && t.classList.contains('brand-header__drawer')) {
      var r = t.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) { t.close(); return; }
    }

    var search = t.closest('[data-brand-header-search]');
    if (search) {
      var modal = D.getElementById('search-modal');
      if (modal && typeof modal.showDialog === 'function') {
        e.preventDefault();
        closeDrawers();
        modal.showDialog();
      }
      return; /* modal yoksa /search sayfasına gider */
    }

    var cartLink = t.closest('[data-brand-header-cart]');
    if (cartLink) {
      var B = window.BRAND;
      var onCart = B && B.template && B.template.name === 'cart';
      var cd = D.querySelector('cart-drawer-component');
      if (!onCart && cd && typeof cd.open === 'function') {
        e.preventDefault();
        closeDrawers();
        cd.open();
      }
      return; /* çekmece yoksa /cart sayfasına gider */
    }

    /* çekmecedeki bir linke gidiliyor: çekmeceyi kapat (aynı sayfa içi #link ise de) */
    if (t.closest('dialog.brand-header__drawer a[href]')) closeDrawers();
  });

  D.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var a = D.activeElement;
    var it = deckItem(a);
    if (it) {
      var nav = it.closest('.brand-header__nav');
      if (nav) nav.classList.add('is-suppressed');
      it.classList.remove('is-open');
      setExpanded(it, false);
      var trig = it.querySelector('.brand-header__trigger');
      if (trig) trig.focus({ preventScroll: true });
      return;
    }
    closeDecks(null);
  });

  /* ---------------- 5. sepet sayacı ---------------- */
  function setCount(n) {
    if (typeof n !== 'number' || isNaN(n)) return;
    all('[data-brand-bind="cart.count"]').forEach(function (el) {
      el.textContent = n > 99 ? '99+' : String(n);
      el.hidden = !(n > 0);
    });
    all('[data-brand-bind="cart.label"]').forEach(function (el) {
      el.textContent = el.textContent.replace(/\d+\s*$/, String(n));
    });
    schedule();
  }
  var pending = 0;
  function refreshCount() {
    clearTimeout(pending);
    pending = setTimeout(function () {
      var url = (routes().cart || '/cart') + '.js';
      if (!window.fetch) return;
      fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (c) { if (c && typeof c.item_count === 'number') setCount(c.item_count); })
        .catch(function () {});
    }, 200);
  }
  D.addEventListener('cart:update', function (e) {
    var res = e && e.detail && e.detail.resource;
    if (res && typeof res.item_count === 'number') setCount(res.item_count);
    else refreshCount();
  });
  /* Horizon olayı atmayan sepet yazımları (uygulama blokları, GSW / Drip akışları): kaynak zamanlamasından yakalanır,
     window.fetch'e dokunulmaz. Kendi /cart.js okumamız desenle eşleşmez (döngü yok). */
  try {
    if (window.PerformanceObserver) {
      new PerformanceObserver(function (list) {
        list.getEntries().forEach(function (en) {
          if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(en.name)) refreshCount();
        });
      }).observe({ type: 'resource', buffered: false });
    }
  } catch (err) { /* desteklenmiyor: yalnız cart:update */ }
  window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCount(); });
  /* iframe içindeki sepet yazımı (GSW uygulamasının ürün ekleme mesajı; aynı köken) kaynak zamanlamasına düşmez */
  window.addEventListener('message', function (e) {
    if (e.origin !== location.origin || !e.data || typeof e.data !== 'object') return;
    if (e.data.type === 'gsw:blanks-added') refreshCount();
  });

  /* ---------------- 6. auto-fit + yükseklik değişkenleri ---------------- */
  var raf = 0;
  function overflows(inner) {
    var last = inner.lastElementChild;
    if (!last) return false;
    var cs = getComputedStyle(inner);
    var right = inner.getBoundingClientRect().right - parseFloat(cs.paddingRight || 0);
    var nav = inner.querySelector('.brand-header__nav');
    var actions = inner.querySelector('.brand-header__actions');
    if (actions && actions.getBoundingClientRect().right > right + 0.5) return true;
    if (nav && actions && nav.offsetParent !== null && nav.getBoundingClientRect().right > actions.getBoundingClientRect().left + 0.5) return true;
    return inner.scrollWidth > inner.clientWidth + 1;
  }
  function fit(hdr) {
    var inner = hdr.querySelector('.brand-header__inner');
    if (!inner) return;
    for (var n = 0; n <= FIT_MAX; n++) {
      hdr.setAttribute('data-fit', String(n));
      if (!overflows(inner)) return;
    }
  }
  function heights() {
    var hdr = headers()[0];
    var bar = hdr ? hdr.querySelector('.brand-header__bar') : null;
    var hh = bar ? Math.round(bar.getBoundingClientRect().height) : 0;
    var ann = 0;
    all('[data-brand-component="announcement"]').forEach(function (a) { ann += a.getBoundingClientRect().height; });
    if (D.body) {
      D.body.style.setProperty('--header-height', hh + 'px');
      D.body.style.setProperty('--header-group-height', Math.round(ann) + 'px');
    }
    var sec = hdr ? hdr.parentNode : null;
    var sticky = sec && sec.nodeType === 1 && getComputedStyle(sec).position === 'sticky';
    H.style.scrollPaddingTop = sticky ? hh + 'px' : '';
  }
  function run() {
    raf = 0;
    headers().forEach(function (hdr) {
      fit(hdr);
      /* geniş ekrana geçildi ve menü çubukta görünüyor: açık mobil çekmece kapanır */
      if (DESK && DESK.matches && parseInt(hdr.getAttribute('data-fit'), 10) < 4) {
        all('dialog.brand-header__drawer[open]', hdr).forEach(function (dlg) { dlg.close(); });
      }
    });
    heights();
  }
  function schedule() { if (!raf) raf = requestAnimationFrame(run); }

  /* ---------------- başlat ---------------- */
  function scan(root) {
    all('[data-brand-component="announcement-countdown"]', root).forEach(startCountdown);
    schedule();
  }
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', function () { scan(); });
  else scan();
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('load', schedule);
  window.addEventListener('pageshow', schedule);
  if (D.fonts && D.fonts.ready) D.fonts.ready.then(schedule);
  D.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
